import { Component } from '@angular/core';
import { RelocationDetail } from 'app/core/store/edit-florder-detail/florder-detail.interface';
import { AbstractCalendarFlorderTooltipContainer } from 'app/modules/calendar/common/calendar-tooltip/abstract-calendar-florder-tooltip.container';
import * as relocationDetailActions from 'app/core/store/edit-relocation-detail/relocation-detail.actions';
import { distinctUntilChanged, map, takeWhile } from 'rxjs/operators';

@Component({
  selector: 'app-calendar-relocation-tooltip',
  templateUrl: './calendar-relocation-tooltip.container.html',
  styleUrls: ['../../common/calendar-tooltip/calendar-florder-tooltip.container.scss'],
})
export class CalendarRelocationTooltipContainer extends AbstractCalendarFlorderTooltipContainer {
  relocationDetail: RelocationDetail;
  private loadedEtmOrderNrForTooltip: string;

  protected getFlorderFromStore() {
    this.store
      .pipe(
        takeWhile(() => !this.destroyed),
        map(state => state.editRelocationDetail.relocationDetail),
        distinctUntilChanged()
      )
      .subscribe(relocationDetail => {
        this.relocationDetail = relocationDetail;
        this.loadedEtmOrderNrForTooltip = (relocationDetail && relocationDetail.etmOrderNumber) || null;
      });
  }

  protected loadFlorder() {
    const salesOrderNumber = this.florderInfo.salesOrderNumbers && this.florderInfo.salesOrderNumbers[0];
    if (this.loadedEtmOrderNrForTooltip !== this.florderInfo.etmOrderNumber) {
      this.loadedEtmOrderNrForTooltip = this.florderInfo.etmOrderNumber;
      this.store.dispatch(
        new relocationDetailActions.RelocationDetailOpenAction({
          etmOrderNumber: this.florderInfo.etmOrderNumber,
          salesOrderNumber,
        })
      );
    }
  }
}
